import { Tooltip } from "@heroui/react";
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { Column } from "./Layout";

export default function InfoTooltip({ content }: { content: React.ReactNode }) {

    return (
        <Tooltip color="foreground" content={
            <Column padding={2} maxWidth={"240px"} gap={2}>
                {content}
            </Column>
        }>
            <InfoOutlineIcon style={{ opacity: "0.3" }} />
        </Tooltip>
    )
}